/**
 * @project 中国人群健康大数据平台
 * 
 * @author  Guojun Wang
 * @date    2022-11-21 14:00:00
 **/ 

export const BannerDataSource = {
  wrapper: { className: 'banner' },
  textWrapper: {
    className: 'banner-text-wrapper',
    children: [
      {
        name: 'nameEn',
        className: 'banner-name-en',
        children: 'Seeking Experience & Engineering Conference',
      },
      {
        name: 'slogan',
        className: 'banner-slogan',
        children: '中国人群健康大数据平台',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner-name',
        children: '探索极致用户体验与最佳工程实践探索',
      },
      { name: 'button', className: 'banner-button', children: '立即报名' },
      {
        name: 'time',
        className: 'banner-time',
        children: '2018.01.06 / 中国·杭州',
      },
    ],
  },
};

export const BannerItemsConfig = [{
  id: 1,
  url: '/assets/images/software-icon/GCTA.png',
  active: '/assets/images/software-icon/GCTA-反.png',
  href: '/software-gcta',
  name: 'GCTA',
  fullName: 'Genome-wide Complex Trait Analysis (GCTA)'
}, {
  id: 2,
  url: '/assets/images/software-icon/SMR.png',
  active: '/assets/images/software-icon/SMR-反.png',
  href: '/software-smr',
  name: 'SMR',
  fullName: 'Summary-data-based Mendelian Randomisation (SMR)'
}, {
  id: 3,
  url: '/assets/images/software-icon/GSMR.png',
  active: '/assets/images/software-icon/GSMR-反.png',
  href: '/software-gsmr',
  name: 'GSMR',
  fullName: 'Generalised Summary-data-based Mendelian Randomisation (GSMR)'
}, {
  id: 4,
  url: '/assets/images/software-icon/OSCA.png',
  active: '/assets/images/software-icon/OSCA-反.png',
  href: '/software-osca',
  name: 'OSCA',
  fullName: 'OmicS-data-based Complex trait Analysis(OSCA)'
}, {
  id: 5,
  url: '/assets/images/software-icon/DENTIST.png',
  active: '/assets/images/software-icon/DENTIST-反.png',
  href: 'https://github.com/Yves-CHEN/DENTIST',
  name: 'DENTIST',
  fullName: 'Detecting Errors in analyses of summary staTISTics (DENTIST)'
}, {
  id: 6,
  url: '/assets/images/software-icon/THISTLE.png',
  active: '/assets/images/software-icon/THISTLE-反.png',
  href: 'https://yanglab.westlake.edu.cn/software/osca/#THISTLE',
  name: 'THISTLE',
  fullName: 'Testing for Heterogeneity between isoform-eQTL effects (THISTLE)'
}];

export const BannerOnlineConfig = [{
  id: 1,
  url: '/assets/images/fastgwa_i3.svg',
  href: '/data-imputed',
  name: 'fastGWA data portal'
}, {
  id: 2,
  url: '/assets/images/brainmeta_i3.svg',
  href: '/meta-cis-sQTL',
  name: 'BrainMeta data portal'
}];
